import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
// import { MatSnackBar } from '@angular/material/snack-bar';
import { ValidationService } from '../../core/services/validation.service';

@Component({
    selector: 'forgot-password-component',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent {
    isSend: boolean;
    email = '';
    constructor(
        private validationService: ValidationService,
        // private _snackBar: MatSnackBar,
        // private apiService: AuthAppService,
    ) {
        this.isSend = false;
    }

    submit(form: NgForm) {
        if (form.valid) {
            // this.apiService.forgotPassword(this.email).subscribe(
            //     res => {
            //         if (res) {
            //             this.isSend = true;
            //         } else {
            //             this._snackBar.open('Please contact the customer service for more information!', 'x', {
            //                 horizontalPosition: 'right',
            //                 verticalPosition: 'top',
            //                 panelClass: ['notif-error'],
            //                 duration: 3000,
            //             });
            //         }
            //     },
            //     err => {
            //         console.log(err);
            //     },
            // );
            // console.log('huhu');
            // this.cognitoService.forgotPassword(this.email).then(()=> {
            //     this.isSend = true;
            // }).catch((error) => {
            //     this._snackBar.open(error.message, 'x', {
            //         horizontalPosition: 'right',
            //         verticalPosition: 'top',
            //         panelClass: ['notif-error'],
            //         duration: 3000
            //       });
            // });
        }
    }

    validatorEmail: any = (c: any) => {
        return this.validationService.email(c);
    };
}
